import { Cookie } from "lucide-react";
import LegalPageLayout from "../components/LegalPageLayout";

const sections = [
  {
    id: "overview",
    title: "1. What this policy covers",
    body: [
      "This policy explains how the EXOPILOT cloud console and marketing site use cookies and similar browser storage. It does not apply to your on-premise local server, which has no web-tracking surface at all.",
    ],
  },
  {
    id: "what-we-use",
    title: "2. What we actually use",
    body: [
      "EXOPILOT is a console you sign into to run your business, not a content site — so our cookie footprint is intentionally small. We do not run third-party advertising trackers, and we do not sell or share browsing data.",
    ],
    list: [
      "Strictly necessary: a short-lived, httpOnly, secure session cookie that keeps you signed in. Without it the console cannot function — there is no way to opt out of this one while staying signed in.",
      "Preference storage: your browser's local storage remembers small UI preferences (like a collapsed sidebar or a selected date range) on the device you're using. This never leaves your browser.",
      "No analytics or advertising cookies are set by the console today. If that changes, this policy — and an on-page notice — will be updated first.",
    ],
  },
  {
    id: "third-party",
    title: "3. Third parties",
    body: [
      "We do not embed third-party ad networks, social widgets, or cross-site trackers in the console or marketing site. Infrastructure providers (hosting, database) may see standard connection metadata (IP address, timestamps) as an operational necessity of serving the page — this is not cookie-based tracking and is covered by our Privacy Policy.",
    ],
  },
  {
    id: "control",
    title: "4. Managing cookies",
    body: [
      "Because the only cookie we set is strictly necessary for authentication, blocking it will simply sign you out and prevent sign-in. You can clear cookies and local storage at any time from your browser's settings — doing so on the console just means signing in again.",
    ],
  },
  {
    id: "changes",
    title: "5. Changes to this policy",
    body: [
      "If our cookie usage ever expands beyond what's described here, we will update this page and, for material changes, notify workspace administrators the same way we do for Privacy Policy changes.",
    ],
  },
  {
    id: "contact",
    title: "6. Contact",
    body: [
      "Questions about cookies or browser storage: privacy@exopilot.io",
    ],
  },
];

export default function Cookies() {
  return (
    <LegalPageLayout
      testId="cookies"
      eyebrowIcon={Cookie}
      eyebrow="Cookies Policy"
      title="A short policy,"
      accent="because we set almost nothing."
      updated="June 2026"
      sections={sections}
      contactLine="Questions about cookies or browser storage?"
      contactEmail="privacy@exopilot.io"
    />
  );
}
